/**
 * Müşteri adı gösterimi (03.11.2026): her sözcüğün ilk harfi büyük, kalanı küçük, Türkçe kurallarıyla (i -> İ, ı -> I).
 * İki harfli büyük kısaltmalar (AB, UK) bozulmaz. Veritabanındaki kayıt değişmez; yalnız gösterimde biçimlenir.
 * Api kopyası: api/src/modules/hizli-teklif/musteri-adi.ts (bir test iki kopyayı kilitler).
 */
export function musteriAdiBicimle(ad: string | null | undefined): string {
  if (ad === null || ad === undefined) return '';
  return ad
    .trim()
    .split(/([\s'’-]+)/)
    .map((parca, i) => {
      if (i % 2 === 1 || parca === '') return parca;
      if (/^[A-ZÇĞİÖŞÜ]{2}$/.test(parca)) return parca;
      const [ilk = '', ...kalan] = Array.from(parca);
      return ilk.toLocaleUpperCase('tr-TR') + kalan.join('').toLocaleLowerCase('tr-TR');
    })
    .join('');
}
